<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/33QYFv/tc-custom/9781459212268.jpg?1726519051799" alt="This image is the cover for the book His Medicine Woman, Men of the West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Medicine Woman, Men of the West
      </h1>
      <p class="bookDescription body article font2">
        <b>A man like Johnny Chino</b><br/><br/>was impossible to forgetalthough for five long years Bridget Donovan had certainly tried. But when the proud Apache asked for help, Bridget's job as a doctor wouldn't let her say no. Being so close to the man who'd broken her heart would be a trial, and she vowed never to fall for him again.<br/><br/>Johnny was certain he'd done the right thing in breaking it off with Bridget. She deserved so much more than someone like him. Yet having her near reminded him of all he'd given up when he'd pushed her away. And those feelingsno matter how much he ignored themweren't going away.<br/><br/>Sometimes, what's meant to be just can't be denied.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stella Bagwell
      </h2>
      
      <p class="authorDescription body article">The author of over seventy-five titles for Harlequin, Stella Bagwell writes about familes, the West, strong, silent men of honor and the women who love them. She credits her loyal readers and hopes her stories have brightened their lives in some small way. A cowgirl through and through, she recently learned how to rope a steer. Her days begin and end helping her husband on their south Texas ranch. In between she works on her next tale of love. Contact her at stellabagwell@gmail.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?211a8271